<template>

    <div v-if="show" class="form_btn_container" id="form_btn_container">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <h3 style="color: var(--titulo);">{{ form_title }}:</h3>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <HistoricoObjetoButton
                    model-name="Fornecedor"
                    :objeto-id="form_data.id"
                    modelo-label="Fornecedor"
                    variant="bare"
                    icon-only
                />
                <AppButton style="color: var(--icon);" v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                    @close="close" :width=20 :height=20 />
            </div>
        </div>
        <div class="form_container">

            <div id="left_form" class="left_form">

                <div class="input_container">
                    <label for="nome" class="input_label">Nome:</label>
                    <input
                        :disabled="form_data.status == 'desativado'" type="text" v-model="formData.nome" placeholder="Nome" class="input_field"
                        :class="{ 'input-required': isEmptyField('nome') }">
                </div>

                <div class="input_container">
                    <label for="nif" class="input_label">NIF:</label>
                    <input
                        :disabled="form_data.status == 'desativado'" type="text" v-model="formData.nif" placeholder="NIF" class="input_field"
                        :class="{ 'input-required': isEmptyField('nif') }">
                </div>

                <div style="display: flex; ">
                    <label style="min-width: 7rem;">Descrição:</label>
                    <textarea :disabled="form_data.status == 'desativado'" v-model="formData.descricao" placeholder="Descrição" class="input_field textarea"
                        style="resize: none;"></textarea>
                </div>

            </div>

            <div id="right_form" class="right_form">
                <div class="img_container">
                    <div class="img_btn_container">
                        <div class="img_container">
                            <img id="fornecedor_img" :src="formData.foto" alt="fornecedor image">
                        </div>

                        <div style="margin-top: 0.5rem;">
                            <label for="input-file">
                                <i class="fa-solid fa-circle-plus fa-xl" :style="{ color: form_data.status == 'desativado' ? 'var(--desativado)' : 'var(--icon)',cursor: form_data.status == 'desativado' ? 'not-allowed' : 'pointer' }"></i>
                            </label>
                            <input :disabled="form_data.status == 'desativado'" type="file" accept="image/*" id="input-file" @change="upload_img" hidden>
                        </div>

                    </div>

                </div>
                <div class="right_input_container">

                    <div class="contato_container">
                        <div class="flex gap-2 items-center">
                            <label for="password" class="">Morada:</label>
                            <h4 class="text-[var(--icon)] ">{{ set_data.endereco.pais }}{{ set_data.endereco.pais=='N/A'?'':',..' }} </h4>
                            <!-- <input type="text" v-model="set_data.endereco.nome" placeholder="Morada"> -->
                            <AppButton v-if="this.validPermission('F0017')" :disabled="form_data.status == 'desativado'"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square" text="Lat,Long no Mapa" emitType="select" @select="selectTable('mapa')" />
                        </div>
                    </div>


                </div>
                <div  style="display: flex; gap: 0.5rem; padding: 0rem; align-self: flex-start;">
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0009')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square" text="Produtos" emitType="select" @select="selectTable('produtos')" />
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0010')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square" text="Tabela Preços" emitType="select" @select="selectTable('preços')" />
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0011')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square" text="Armazem" emitType="select" @select="selectTable('armazem')" />
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0012')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square" text="Contacto" emitType="select" @select="selectTable('contacto')" />
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0020')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square" text="Artigos" emitType="select" @select="selectTable('artigo')" />
                    
                </div>

                <div  style="display: flex; gap: 0.5rem; padding: 0rem; align-self: flex-start;">
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0013')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square"   text="Faturação" emitType="select" @select="selectTable('faturação')" />
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0014')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square" text="Orçamentos" emitType="select" @select="selectTable('orçamentos')" />
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0015')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square"    text="Encomenda" emitType="select" @select="selectTable('encomenda')" />
                    <AppButton :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0016')"  v-bind:visibility="true" :font_size="11"  :color="form_data.status == 'desativado' ? '#7B7B99' : '#9797EF'" left_icon="fa-solid fa-pen-to-square"    text="Recolha/Entrega" emitType="select" @select="selectTable('recolha')" /> 
                </div>

            </div>
        </div>
        <div style="display: flex; gap: 0.5rem; padding: 1rem;"> 

            <button v-if="create_btn && this.validPermission('F0018')" class="btn" @click="showConfirm($event, 'create')">Criar</button>
            <button :disabled="form_data.status == 'desativado'" v-if="!create_btn && this.validPermission('F0018')" class="btn" :style="{ backgroundColor: form_data.status !== 'ativo' ? '#7B7B99' : 'rgb(0, 102, 152)' }" @click="showConfirm($event, 'update')">Atualizar</button>
            <AppButton v-if="this.validPermission('F0019')" :visibility="!create_btn" :font_size="11" color="red"
                :text="form_data.status === 'ativo' ? 'Desativar' : 'Ativar'" @click="showConfirm($event, 'disable')" />
            <!-- <ConfirmPopup id="confirm" aria-label="popup" />

            <Button @click="openPopup($event)" label="Confirm" id="confirmButton" :aria-expanded="isVisible" :aria-controls="isVisible ? 'confirm' : null" /> -->

            <!-- <button @click="showConfirm($event, 'tipo')">Show Confirm</button>-->
           <ConfirmPopUp ref="myConfirm" @accept="onAccept" /> 

            <!-- <button @click="showConfirm($event, 'terminar')">Show Confirm</button> -->

        </div>
    </div>
</template>

<script>
import AppButton from '@/components/updated/button.vue';
import permissionMixin from '@/permissionMixin.js'
import ConfirmPopUp from '@/components/modals/MyConfirmPopUp.vue';
import { toast } from 'vue3-toastify';
import HistoricoObjetoButton from '@/components/historico/HistoricoObjetoButton.vue';



export default {
    mixins: [permissionMixin],
    name: 'AppUserForm',
    components: {
        AppButton,
        ConfirmPopUp,
        HistoricoObjetoButton,
        // Faturacao2
    },
    props: {
        form_data: {
            type: Object,
            default: () => ({}),
        },
        set_data: {
            type: Object,
            default: () => ({}),
        },
        show: {
            type: Boolean,
            default: () => false,
        },
        form_title: {
            type: String,
            default: () => "No Title"

        },
        create_btn: {
            type: Boolean,
            default: () => false
        },
        update_visibility: {
            type: Boolean,
            default: () => false
        },
        disable_visibility: {
            type: Boolean,
            default: () => false
        }

    },

    data() {
        return {
            formData: {},
            baseURl: process.env.VUE_APP_URL_BASE,
            emit_type: '',
        };
    },
    mounted() {
        // console.log("ID DO FORnecedor: ", this.form_data.id)
        // this.formData.tipo_utilizador = this.form_data.tipo_utilizador[0];
    },
    methods: {
        
        showConfirm(event, message) {
            this.emit_type=message;
            this.$refs.myConfirm.show(event.target);
        },
        onAccept() {
            if(this.emit_type=='create'){
                this.create();
            }
            else if(this.emit_type=='update'){
                this.update();
            }
            else if(this.emit_type=='disable'){
                this.disable();
            }
    
            else{

                this.$emit('show_table', this.emit_type);
            }

            console.log('Confirmed!');
        },
 
        selectTable(name) {
            console.log("select:", name)
            this.$emit('show_table', name); 
        },

        async upload_img(event) {
            console.log("inside upload method");
            const file = event.target.files[0]; // Get the selected file
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = document.getElementById('fornecedor_img');
                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);

                const formData = new FormData();
                formData.append('foto', file);
                this.formData.newFoto = formData;
                
            }
        },
               
        create() {
            if (!this.isValidForm()) return
            

            const formData = this.getFormData();
            //console.log("create formdata:", formData)
            this.$emit('create', formData);

        },
        update() {
            if (!this.isValidForm()) return
            const formData = this.getFormData();
            //console.log("update formdata:", formData)
            this.$emit('update', formData);

        },

        disable() {
            //if(!this.isValidForm()) return
            const formData = this.getFormData();
            //console.log("disable formdata:", formData)
            this.$emit('disable', formData);

        },
        isValidForm() {
    let missingFields = [];

    if (!this.formData.nome) missingFields.push("Nome");
    if (!this.formData.nif) missingFields.push("NIF");

    if (missingFields.length > 0) {
        toast(`Preencha os campos obrigatórios: ${missingFields.join(", ")}`, {
            theme: "auto",
            type: "warning",
            position: "top-center",
            autoClose: 2000,
        });
        return false;
    }

    return true;
}
,
        // isValidForm() {

        //     if (!this.formData.nome || !this.formData.nif) {
        //         toast("Preencha todos os campos obrigatórios!", {
        //                 "theme": "auto",
        //                 "type": "warning",
        //                 "position": "top-center",
        //                 "autoClose": 1000,
        //         });
        //         return false;
        //     }
        //     return true;
        // },
        // isValidForm() {

        //     if (!this.formData.matricula || !this.formData.marca || !this.formData.modelo) {
        //         return false;
        //     }
        //     if (Array.isArray(this.formData.tipo_viatura)) {
        //         return false;
        //     }


        //     if (!this.formData.tipo_viatura || typeof this.formData.tipo_viatura !== 'object') {
        //         return false;
        //     }
        //     for (const key in this.formData.tipo_viatura) {
        //         if (this.formData.tipo_viatura[key] === null) {
        //             return false;
        //         }
        //     }

        //     return true;
        // },

        getFormData() {

            const formDataObject = {
                ...this.formData,
                ...this.set_data
            };


            return formDataObject;
        },
        close() {
            this.$emit('close');
        },
        updateFormData() {
            this.formData = { ...this.form_data };
           // this.get_imagem(this.formData.id);
            console.log("form data:", this.formData)
        },
        isEmptyField(field) {
            if (["nome", "nif", "descricao"].includes(field)) {
                return !this.formData[field] || Array.isArray(this.formData[field]);
            }
            return false;
        },
        address_is_empty(address){
            return Object.values(address).every(x => (x === null || x === ''));
        }
    },




    // setup() {
    //     const confirm = useConfirm();
    //     const isVisible = ref(false);

    //     const openPopup = (event) => {
    //         confirm.require({
    //             target: event.currentTarget,
    //             message: 'Are you sure you want to proceed?',
    //             header: 'Confirmation',
    //             acceptLabel: 'Yes',
    //             rejectLabel: 'No',
    //             accept: () => console.log('Accepted'),
    //             reject: () => console.log('Rejected'),
    //             onShow: () => isVisible.value = true,
    //             onHide: () => isVisible.value = false
    //         });
    //     }

    //     return {
    //         openPopup,
    //         isVisible
    //     };
    // },

    watch: {
        form_data: {
            handler() {

                // console.log("ID DO FORnecedor: ", this.form_data.id)
                this.updateFormData();
                //this.isEmptyContactField()
            },
            immediate: true,
            deep: true,
        },
    },


}
</script>



<style scoped>
@import 'primevue/resources/themes/aura-light-green/theme.css';
@import 'primevue/resources/themes/saga-blue/theme.css';
@import 'primevue/resources/primevue.min.css'; 
@import 'primeicons/primeicons.css'; 
.form_btn_container {

    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: var(--fundoForm);
    padding: 1rem;
}

.form_container {
    display: flex;
    gap: 1rem;
    padding: 1rem;
    border-radius: 10px;
}


.left_form {
    display: flex;
    flex-direction: column;
    /* gap: 0.2rem; */
    gap: 1rem;
}

h3 {
    display: flex;
    padding: 0.4rem;
    color: var(--label);
}

label {
    display: block;
    color: var(--label);
    /* font-weight: bold; */
    font-size: 14px;
    padding: 0.2rem;
    min-width: 1rem;
    text-wrap: nowrap;
}


input[type="text"],
input[type="password"],
select {
    /* width: 20px; */
    padding: 0.3rem;
    /* Reduce padding */
    font-size: 10px;
    /* Decrease font size */
    border-radius: 5px;
    border: 1px solid #cccccc;

}

.input_field.textarea {
    /* Define width and height as needed */
    width: 200px;
    height: 100px;
    background-color: var(--label);
    color: var(--text);
    /* Add other styles as needed */
}

.btn_div {
    color: white;
    display: flex;
    padding-left: 1rem;
    align-items: center;
    gap: 0.6rem;
}

.btn {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background-color: rgb(0, 102, 152);
    background-color: #006698;
    color: white;
    border: none;
    border-radius: 10px;
    padding: 0.5rem 0.8rem;
    cursor: pointer;
    gap: 0.5rem;
}

.data_set_class {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 10px;
    background-color: var(--label);
}

.data_set {

    font-size: 14px;
    color: var(--label);
    display: flex;
    gap: 0.3rem;
}

.right_form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.5rem;
    align-items: center;
    /* display: none; */

}

.img_container {
    margin-top: -0.5rem;
    /* margin-left: 3rem; */
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
}

.img_btn_container {
    display: flex;
    gap: 0.5rem;
}

.img_container {
    display: flex;
    width: 150px;
    aspect-ratio: 1/1;
    height: auto;

}

.img_container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
}


.signature_container {
    display: flex;
    gap: 1rem;
}

.tpa_certificado_container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.signature_div {
    display: flex;
    gap: 1rem;
}

.signature_field_container {
    display: flex;
    width: 100px;
    height: auto;
    background-color: #626288;
    border-radius: 0.2rem;
}

.signature_field_container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.2rem;
}

.signature_icon_container {
    display: flex;
    justify-content: center;
    /* align-items: center; */
    padding-top: 1rem;

}

.right_input_container {

    /* padding: 0.8rem; */
    margin-top: 0.5rem;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    /* border:1px solid white; */
    border-radius: 0.5rem;
    /* background-color: rgba(93, 93, 152, 0.55); */


}

/* .signature_img_container i{
        margin-top:1rem
    } */

.input_container {
    display: flex;
    align-items: center;
    gap: 1rem;
    color: var(--text);
    /* Adjust spacing between label and input field */
}

.input_label {
    width: 100px;
    /* Adjust label width as needed */
    color: var(--label);
    font-size: 14px;
}

.input_field {
    flex: 1;
    /* Take remaining space */
    padding: 0.3rem;
    font-size: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.rae_container {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border-radius: 10px;
    padding: 1rem;
    background-color: rgba(93, 93, 152, 0.55);
}


</style>
